import { Typography } from '@/components/common';
import { Metrics } from '@/interfaces';
import clsx from 'clsx';
import * as React from 'react';

export interface BarChartProps {
	metricsArray: Metrics[];
	classNameContainer?: string;
	classNamePercentage?: string;
	classNameItem?: string;
	classNameDivider?: string;
}

export const BarChart: React.FC<BarChartProps> = ({
	metricsArray,
	classNameContainer,
	classNameItem,
	classNameDivider,
	classNamePercentage,
}) => {
	const maxPercentage = Math.max(
		...metricsArray.map((item) => item.percentage)
	);

	return (
		<ul className={clsx('flex flex-col pr-2', classNameContainer)}>
			{metricsArray.map((item, index) => {
				const normalizedPercentage =
					maxPercentage === 0 ? 0 : (item.percentage / maxPercentage) * 100;

				return (
					<li
						key={'client-segmetation' + item.title}
						className={clsx(
							'flex items-center gap-x-1',
							classNameItem,
							classNameDivider && index < metricsArray.length - 1
								? classNameDivider
								: 'border-none'
						)}
					>
						<Typography
							type="semibold-20"
							className={clsx('text-grey-80 min-w-[60px]', classNamePercentage)}
						>
							{item.percentage}%
						</Typography>
						<div className="w-full">
							<span
								className="block h-2 rounded max-w-full"
								style={{
									width:
										item.percentage === 0 ? '4px' : `${normalizedPercentage}%`,
									backgroundColor:
										item.percentage === 0 ? '#D2D2D2' : item.color,
								}}
							/>
							<Typography type="semibold-12" className="text-grey-80 text-left">
								{item.title}
							</Typography>
						</div>
					</li>
				);
			})}
		</ul>
	);
};
